module.exports = __webpack_public_path__ + "static/fonts/NanumSquareNeoTTF-eHv.3a44554.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NanumSquareNeoTTF-eHv.eot
// module id = yHsW
// module chunks = 0